import { render, staticRenderFns } from "./dropdown-menu.vue?vue&type=template&id=20db476c&"
import script from "./dropdown-menu.vue?vue&type=script&lang=ts&"
export * from "./dropdown-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20db476c')) {
      api.createRecord('20db476c', component.options)
    } else {
      api.reload('20db476c', component.options)
    }
    module.hot.accept("./dropdown-menu.vue?vue&type=template&id=20db476c&", function () {
      api.rerender('20db476c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/dropdown-menu.vue"
export default component.exports